<script lang="ts">
  import { ui } from '../game/store.ts';

  let left = $derived.by(() => {
    const s = $ui.speech;
    if (!s) return 0;
    const half = Math.min(170, window.innerWidth / 2 - 14);
    return Math.max(half + 12, Math.min(window.innerWidth - half - 12, s.x));
  });
  let top = $derived.by(() => {
    const s = $ui.speech;
    if (!s) return 0;
    return Math.max(80, s.y - 10);
  });
</script>

{#if $ui.speech}
  <div class="bubble" style:left="{left}px" style:top="{top}px" role="status" aria-live="polite" data-testid="speech">
    {$ui.speech.text}
    <span class="tail" style:left="calc(50% + {$ui.speech.x - left}px)"></span>
  </div>
{/if}

<style>
  .bubble {
    position: fixed;
    transform: translate(-50%, -100%);
    max-width: min(340px, calc(100vw - 24px));
    width: max-content;
    padding: 12px 16px;
    border-radius: 16px;
    background: var(--paper);
    color: var(--ink);
    font-size: 1.05rem;
    line-height: 1.4;
    box-shadow: 0 8px 26px rgba(5, 8, 14, 0.55);
    z-index: 30;
    pointer-events: none;
    animation: pop 0.18s ease-out both;
  }
  .tail {
    position: absolute;
    bottom: -9px;
    width: 18px;
    height: 18px;
    background: var(--paper);
    transform: translateX(-50%) rotate(45deg);
    border-radius: 3px;
    max-width: none;
  }
  @keyframes pop {
    from {
      opacity: 0;
      transform: translate(-50%, -92%) scale(0.96);
    }
  }
</style>
